// extracted by mini-css-extract-plugin
export default {"dropbox":"styles_dropbox__At3BS","icon":"styles_icon__QZH9l"};